import { call, take, put } from 'redux-saga/effects';
import { get } from '../../utils/api';
import settings from '../../utils/settings';

import {
  GET_SOLARGRAF_PROJECTS_REQUEST,
  GET_SOLARGRAF_PROJECTS_SUCCESS,
  GET_SOLARGRAF_PROJECTS_FAILURE,
  GET_SOLARGRAF_PROJECT_DETAILS_REQUEST,
  GET_SOLARGRAF_PROJECT_DETAILS_SUCCESS,
  GET_SOLARGRAF_PROJECT_DETAILS_FAILURE
} from './constants';

let getSolargrafProjectsRequest = false;
export function* getSolargrafProjectsFlow() {
  while (true) {
    const request = yield take(GET_SOLARGRAF_PROJECTS_REQUEST);
    if (!getSolargrafProjectsRequest) {
      getSolargrafProjectsRequest = true;
      try {
        let response;
        const {
          after = '',
          limit = '',
          sort = '',
          desc = '',
          successCbk = () => {},
          sgToken = '',
          stateFilter = '',
          next = '',
          previous = '',
          search = ''
        } = request.payload;
        let url = '';
        if (next || previous) {
          url = settings.solargrafApiUrl((next || previous).substring(1));
        } else {
          url = settings.solargrafApiUrl(
            `projects?after=${after}&limit=${limit}&state=${stateFilter}&sort=${sort}&desc=${desc}&search[0]=${search}`
          );
        }
        response = yield call(get, {
          url: url,
          withBearer: true,
          externalServiceToken: sgToken
        });
        getSolargrafProjectsRequest = false;
        if (response.success) {
          successCbk(response.result);
          yield put({
            type: GET_SOLARGRAF_PROJECTS_SUCCESS,
            sgProjectsData: response.result
          });
        } else {
          yield put({
            type: GET_SOLARGRAF_PROJECTS_FAILURE,
            message: response.result.message || response.result.messages
          });
        }
      } catch (error) {
        getSolargrafProjectsRequest = false;
        yield put({ type: GET_SOLARGRAF_PROJECTS_FAILURE, message: error });
      }
    }
  }
}

let getSolargrafProjectDetailsRequest = false;
export function* getSolargrafProjectDetailsFlow() {
  while (true) {
    const request = yield take(GET_SOLARGRAF_PROJECT_DETAILS_REQUEST);
    if (!getSolargrafProjectDetailsRequest) {
      getSolargrafProjectDetailsRequest = true;
      try {
        let response;
        const { projectPublicId = '', successCbk = () => {} } = request.payload;
        const url = settings.solargrafApiUrl(`public/project/${projectPublicId}`);
        response = yield call(get, {
          url: url
        });
        getSolargrafProjectDetailsRequest = false;
        if (response.success) {
          successCbk(response.result);
          yield put({
            type: GET_SOLARGRAF_PROJECT_DETAILS_SUCCESS,
            sgProjectDetailsData: response.result
          });
        } else {
          yield put({
            type: GET_SOLARGRAF_PROJECT_DETAILS_FAILURE,
            message: response.result.message || response.result.messages
          });
        }
      } catch (error) {
        getSolargrafProjectDetailsRequest = false;
        yield put({ type: GET_SOLARGRAF_PROJECT_DETAILS_FAILURE, message: error });
      }
    }
  }
}
